import {
    notification, Button, Row, Col, Statistic, Card,
} from 'antd'
import React from 'react'
import './index.css'
import SearchOne, { SearchReference } from './SearchOne';
import SearchTwo from './SearchTwo';
import { CopyOutlined } from '@ant-design/icons';
export default function Search({ dataInfo }) {
    const copyText = (placement) => {
        var textToCopy = document.querySelector('.content').innerText;
        navigator.clipboard.writeText(textToCopy)
            .then(function () {
                openNotification(placement)
            }, function (err) {

            });
    }

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement) => {
        api['success']({
            message: `Copy success!`,
            placement
        });
    };

    const titleInfo = (value) => {
        return (<span style={{ fontSize: '18px' }}>
            {value}
        </span>)
    }

    // 覆盖度比例统一按百分比展示，兼容后端返回0-1小数或0-100百分数
    const formatCoveragePercent = (value = 1) => {
        const numberValue = Number(value);
        if (!Number.isFinite(numberValue)) {
            return '-';
        }
        const percentValue = numberValue <= 1 ? numberValue * 100 : numberValue;
        return `${percentValue.toFixed(2)}%`;
    }

    return (
        <Row justify={"center"} className="search-detail-page">
            <Col xs={24} sm={20}>
                {contextHolder}
            </Col>
            <Col xs={24} sm={20} className="search-detail-hero">
                {/* 详情头部突出当前变异位点，并保留一键复制入口 */}
                <Row align={'middle'} justify="space-between" gutter={[16, 16]}>
                    <Col>
                        <div className="variant-hero-title">
                        <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene1.png'
                                alt=""
                        />
                            <div>
                                <span className="variant-hero-label">Variant details</span>
                                <span className='content'>
                            {"Chr" +
                                dataInfo?.searchInfo.searchChr
                                + ':' +
                                dataInfo?.searchInfo.searchPos +
                                '-' +
                                dataInfo?.searchInfo.searchRef +
                                '-' +
                                dataInfo?.searchInfo.searchAlt
                            }
                        </span>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <Button onClick={() => copyText('top')}
                            className="variant-copy-button"
                            icon={<CopyOutlined />}
                        >
                            Copy variant ID
                        </Button>
                    </Col>
                </Row>
            </Col>
            <Col xs={24} sm={20} className="search-summary-wrap">
                <Card className="search-summary-card">
                    <Row className="search-summary-grid">
                        <div className='colName' span={3} >
                            <Statistic title={titleInfo("Quality filter")} value={"Pass"} />
                        </div>
                        <div className='colName' span={3}>
                            <Statistic title={titleInfo("Allele Count")} value={dataInfo?.AC} />
                        </div>
                        <div className='colName' span={3}>
                            <Statistic title={titleInfo("Allele Number")} value={dataInfo?.AN} />
                        </div>
                        <div className='colName' span={3}>
                            <Statistic title={titleInfo("Allele Frequency")} value={dataInfo?.AF} />
                        </div>
                        <div className='colName' span={10}>
                            <Statistic
                                title={titleInfo("Fraction of individuals with >30x coverage")}
                                value={formatCoveragePercent(dataInfo?.coverage30xFraction ?? dataInfo?.fraction30xCoverage ?? 1)}
                            />
                        </div>
                    </Row>
                </Card>
            </Col>
            {/* 详情页布局：摘要与公共数据库详情之间插入Search筛选，Reference固定保留在最底部 */}
            <SearchOne resultInfo={dataInfo} />
            <SearchTwo resultInfo={dataInfo} />
            <SearchReference resultInfo={dataInfo} />

        </Row >
    )
}
